import {useMediaQuery} from "@react-hook/media-query";
import * as React from "react";
import Section from "../Layout/Section";
import Slider from "../Common/Slider";
import SliderPagination from "../Common/Slider/Pagination";
import * as styles from "./advantages.module.css";
import TemplateString from "../Common/TemplateString";

const SolutionAdvantages = ({advantages}) => {
    const showPagination = useMediaQuery("(max-width: 1024px)");

    if (!advantages) {
        return null;
    }

    return (
        <Section title={advantages.title}>
            <Slider
                sliderClassName={styles.advantages__slider}
                containerClassName={styles.advantages__sliderContainer}
                pagination={showPagination && <SliderPagination />}
            >
                {advantages.cards.map(({id, title, description}) => (
                    <div key={id} className={styles.advantages__card}>
                        <h3 className={styles.advantages__cardTitle}>
                            <TemplateString template={title} />
                        </h3>
                        <p className={styles.advantages__cardDesc}>
                            <TemplateString template={description} />
                        </p>
                    </div>
                ))}
            </Slider>
        </Section>
    );
};

export default SolutionAdvantages;
